var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-processing-modal" },
    [
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("chatbotv2.imageProcessingSettings.title"),
            visible: true,
            footer: null,
            width: "1050px",
            maskClosable: false,
          },
          on: {
            cancel: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          _c("ImageProcessingSettings", {
            attrs: { storyId: _vm.storyId },
            on: {
              close: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }